import { showRegenerateTokenState } from '@/atoms';
import { useRegenerateToken } from '@/services/tokens';
import { Button, Group, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { ModalLayout } from 'moh-ui';
import { useQueryClient } from 'react-query';
import { useRecoilState } from 'recoil-next';

export default function RegenerateTokenModal() {
   const [show, setShow] = useRecoilState(showRegenerateTokenState);
   const queryClient = useQueryClient();
   const { mutate: regenerateToken, isLoading } = useRegenerateToken();

   const handleClose = () => {
      setShow(null);
   };

   const handleRegenerate = () => {
      if (show?.token) {
         regenerateToken(show.token.id, {
            onSuccess: () => {
               queryClient.invalidateQueries('tokens');
               showNotification({
                  title: 'Success',
                  message: 'Token regenerated successfully',
                  color: 'green',
               });
               handleClose();
            },
            onError: (error) => {
               showNotification({
                  title: 'Error',
                  message: error.message || 'Failed to regenerate token',
                  color: 'red',
               });
            },
         });
      }
   };

   return (
      <ModalLayout open={Boolean(show?.show)} onClose={handleClose} size="md">
         <h2 className="text-xl font-semibold">Regenerate Token</h2>
         <Text mt="md">Are you sure you want to regenerate this token? This action cannot be undone.</Text>
         <Group mt="xl">
            <Button variant="outline" onClick={handleClose} disabled={isLoading}>
               Cancel
            </Button>
            <Button color="blue" onClick={handleRegenerate} loading={isLoading}>
               Regenerate
            </Button>
         </Group>
      </ModalLayout>
   );
}
